import { render, staticRenderFns } from "./LightLogo.vue?vue&type=template&id=79280056&"
import script from "./LightLogo.vue?vue&type=script&lang=js&"
export * from "./LightLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports